export default __webpack_public_path__ + "static/Spinner-1c160e1bb455be7d46a05f6f828544bc.gif";